import { render } from "./BuildingView.vue?vue&type=template&id=325e005a"
import script from "./BuildingView.vue?vue&type=script&lang=js"
export * from "./BuildingView.vue?vue&type=script&lang=js"

import "./BuildingView.vue?vue&type=style&index=0&id=325e005a&lang=css"

import exportComponent from "../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@17.4.2_vue@3.5.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__